import { Suspense, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import Button from './Button';
import ReactSelect from './ReactSelect';
import { useTranslation } from 'react-i18next';

const DropdownLocationForm = ({
  departments,
  onApply,
  loading,
  isMultiSelect = false,
  selectedDepartment = '',
  selectedDistrict = [],
}) => {
  const { t } = useTranslation();
  const [department, setDepartment] = useState(selectedDepartment || '');
  const [district, setDistrict] = useState(
    Array.isArray(selectedDistrict)
      ? selectedDistrict
      : [selectedDistrict].filter(Boolean),
  );
  const districtList = department ? (departments[department] ?? []) : [];

  useEffect(() => {
    setDepartment(selectedDepartment || '');
  }, [selectedDepartment]);

  useEffect(() => {
    setDistrict(
      Array.isArray(selectedDistrict)
        ? selectedDistrict
        : [selectedDistrict].filter(Boolean),
    );
  }, [selectedDistrict]);

  const handleApply = (e) => {
    e.preventDefault();
    if (!department) {
      toast.error(t('location.selectDepartment'));
      return;
    }
    onApply({ department, district });
  };

  return (
    <div className='flex flex-col justify-between space-y-5'>
      <Suspense
        fallback={<div className='p-2 text-sm'>{t('common.loading')}...</div>}
      >
        <ReactSelect
          label={t('location.department')}
          value={department}
          items={Object.keys(departments)}
          onChange={(val) => {
            setDepartment(val);
            setDistrict([]);
          }}
        />
        <ReactSelect
          label={t('location.provinceOrDistrict')}
          value={district}
          items={districtList}
          disabled={!department}
          onChange={setDistrict}
          isMultiSelect={isMultiSelect}
        />
      </Suspense>
      <Button
        title={t('common.apply')}
        size='block'
        loading={loading}
        onClick={handleApply}
      />
    </div>
  );
};
export default DropdownLocationForm;
